import { render } from "./TabsSectionMobile.vue?vue&type=template&id=59a56700"
import script from "./TabsSectionMobile.vue?vue&type=script&lang=js"
export * from "./TabsSectionMobile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__